<template>
  <v-container id="extended-tables" tag="section">
    <base-v-component :heading="heading" />
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          rounded
          large
          @click="AddSucursal"
          color="indigo darken-3"
          >Agregar Nueva Sucursal</v-btn
        >
      </template>
      <span></span>
    </v-tooltip>

    <v-layout row wrap>
      <v-col
        cols="12"
        sm="6"
        md="6"
        lg="4"
        xl="4"
        v-for="(item, key) in BranchOffice"
        :key="key"
      >
        <v-hover v-slot:default="{ hover }">
          <base-material-card
            color="white"
            image
            light
            :elevation="hover ? 20 : 2"
            hover-reveal
          >
            <template v-slot:image>
              <v-img
                :aspect-ratio="16 / 9"
                :src="_image(item.bussinessAccount.logo)"
              />
            </template>
            <template v-slot:reveal-actions>
              <template v-if="isAmobile">
                <v-layout row wrap>
                  <v-col cols="12">
                    <v-layout justify-start>
                      <v-avatar size="40" @click="Edit(item)">
                        <v-icon color="green darken-3">mdi-lead-pencil</v-icon>
                      </v-avatar>
                      <strong
                        class="subtitle-1 black--text mx-2 ml-3 mt-2 text-center"
                        >Editar info. de sucursal
                      </strong>
                    </v-layout>
                  </v-col>
                  <v-col cols="12">
                    <v-layout justify-start>
                      <v-avatar size="40" @click="SeeDashboard(item)">
                        <v-icon color="indigo darken-4">mdi-chart-line</v-icon>
                      </v-avatar>
                      <strong
                        class="subtitle-1 black--text mx-2 ml-3 mt-2 text-center"
                        >Ver Dashboar de Sucursal
                      </strong>
                    </v-layout>
                  </v-col>
                  <v-col cols="12">
                    <v-layout justify-start>
                      <v-avatar size="40" @click="ShowPriceList(item)">
                        <v-icon color="indigo darken-4">mdi-view-list </v-icon>
                      </v-avatar>
                      <strong
                        class="subtitle-1 black--text mx-2 ml-3 mt-2 text-center"
                        >Ver/Editar la lista de precios
                      </strong>
                    </v-layout>
                  </v-col>
                </v-layout>
              </template>
              <template v-else>
                <v-tooltip bottom color="green darken-3">
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn
                      color="white"
                      class="mx-2"
                      v-bind="attrs"
                      fab
                      small
                      v-on="on"
                      @click="Edit(item)"
                    >
                      <v-icon color="green darken-3">mdi-lead-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar información de Sucursal</span>
                </v-tooltip>

                <v-tooltip bottom color="blue darken-3">
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn
                      color="white"
                      class="mx-2"
                      v-bind="attrs"
                      small
                      fab
                      v-on="on"
                      @click="SeeDashboard(item)"
                    >
                      <v-icon color="indigo darken-4">mdi-chart-line</v-icon>
                    </v-btn>
                  </template>
                  <span color>Ver Dashboar de Sucursal</span>
                </v-tooltip>
              </template>
            </template>
            <v-card-title class="justify-center font-weight-bold"
              >Nombre Sucursal : {{ item.name }}</v-card-title
            >
            <v-card-text
              class="body-1 text-center mb-3 font-weight-light grey--text text-justify"
            >
              <blockquote
                class="body-1 text-center mb-3 font-weight-light grey--text text-justify"
              >
                Cuenta creada el dia {{ formatDate(item.creationDate) }}, Dueño
                de la cuenta
                <b class="display-1">{{
                  item.bussinessAccount.ownerUser != null
                    ? item.bussinessAccount.ownerUser.name
                    : "SIN DATO"
                }}</b
                >.
              </blockquote>
            </v-card-text>
          </base-material-card>
        </v-hover>
      </v-col>
    </v-layout>

    <modal-negocio
      :mostrar="OpenEdit"
      @finishHim="finishHim"
      :editing="true"
      :persistent="true"
      @CerrarKey="OpenEdit = false"
      :EditedItem="EditedItem"
    ></modal-negocio>

    <new-modal
      :dialog="dialog"
      @Close="closeModal"
      @Finishim="Finishim"
    ></new-modal>

    <modal-dash-branch
      :dialog="seeDialog"
      @Close="seeDialog = false"
      :Items="DataItems"
    ></modal-dash-branch>

    <v-snackbar v-model="snackbar" bottom :timeout="timeout" :color="color">{{
      text
    }}</v-snackbar>
    <!--   <opciones-dialog :dialog="dialog" @Close="closeModal" /> -->
  </v-container>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { isMobile } from "mobile-device-detect";

export default {
  name: "DashboardExtendedTables",
  components: {
    ModalNegocio: () => import("../sucursal"),
    ModalDashBranch: () => import("./ModalDashBranch"),
    NewModal: () => import("./NewMdal"),
  },
  created() {
    this.LoadData();
  },
  methods: {
    ShowPriceList(item) {
      this.BranchData = item;
      this.DialogPriceList = true;
    },
    SeeDashboard(item) {
      this.seeDialog = true;
      this.DataItems = Object.assign({}, item);
    },
    LoadData() {
      let bussinessAccountId = localStorage.getItem("_bussinessAccountId");
      axios
        .get("/api/BranchOffice/GetByAccount/" + bussinessAccountId)
        .then((result) => {
          return result.data;
        })
        .then((data) => {
          this.$store.commit("SET_BRANCH", data);
        });
    },
    finishHim() {
      this.snackbar = true;
      this.timeout = 2000;
      this.color = "#2E7D32";
      this.text = "Exito al registrar la Sucursal";
      this.LoadData();

      this.OpenEdit = false;
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD h:mm:ss a");
    },
    Edit(item) {
      this.EditedItem = [];
      this.EditedItem.push(item);

      this.OpenEdit = true;
    },
    _image(logo) {
      let path = "";
      if (logo != null) {
        path = this.$path + logo.split("/")[3];
      } else {
        path = require("@/assets/114721-OOR4RY-486.jpg");
      }

      return path;
    },
    closeModal() {
      this.dialog = false;

      // this.$store.commit("SET_LOADER", false);
    },
    Finishim(data) {
      this.EditedItem = [];
      this.EditedItem.push(data.data);

      this.OpenEdit = true;

      this.dialog = false;
      this.snackbar = true;
      this.timeout = 3200;
      this.color = "success";
      this.text = "Exito al crear la sucursal";

      /*
      this.LoadData(); */
    },
    AddSucursal() {
      this.bussinessAccountId = localStorage.getItem("bussinessAccountId");
      this.dialog = true;
      //this.$store.commit("SET_LOADER",true)
    },
  },
  data: () => ({
    BranchData: {},
    DialogPriceList: false,
    seeDialog: false,
    DataItems: {},
    snackbar: false,
    timeout: null,
    color: null,
    text: null,
    bussinessAccountId: 0,
    OpenEdit: false,
    heading: null,
    dialog: false,
    EditedItem: [],
    actions: [
      {
        color: "info",
        icon: "mdi-account",
      },
      {
        color: "success",
        icon: "mdi-pencil",
      },
    ],
  }),
  computed: {
    BranchOffice() {
      this.heading =
        "Administrando Sucursales de " + this.$store.state._titleBussines;
      return this.$store.state.BranchOffice;
    },
    isAmobile() {
      return isMobile;
    },
  },
};
</script>
